import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';

const DateRange = (props) => {
    const [dateRange, setDateRange] = useState([props.startDate || null, props.endDate || null]);
    const [startDate, endDate] = dateRange;

    //Sync internal state when parent updates startDate/endDate
    useEffect(() => {
        if ((!props.startDate && !props.endDate) || props.startDate !== startDate || props.endDate !== endDate) {
            setDateRange([props.startDate || null, props.endDate || null]);
        }
    },
    // eslint-disable-next-line 
    [props.startDate, props.endDate]);

    const handleOnChange = (dates) => {
        var [first, last] = dates;
        setDateRange(dates);
        if (!first && !last) {
            props.onChange(dates)
        }
    }

    const onCalendarClose = () => {
        if (startDate && !endDate) {
            let dateRangeCustom = [startDate, props.maxDate]
            setDateRange(dateRangeCustom);
            props.onChange(dateRangeCustom);
        } else {
            props.onChange(dateRange);
        }
    }

    return (
        <DatePicker
            className={props.className}
            placeholderText={props.placeholderText}
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            maxDate={props.maxDate}
            dateFormat={props.dateFormat}
            onChange={handleOnChange}
            onCalendarClose={onCalendarClose}
            isClearable={true}
        />
    );
}

export default DateRange;
